import React, { useState } from "react";
import weblogo from "assets/img/logo.png";
import { Link, NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "components/header/header.css";
import useMediaQuery from "utils/CustonHooks/UseDeviceResponsiveHook";

export default function Header() {
  const [expanded, setExpanded] = useState(false);
  const closeNavbar = () => setExpanded(false);
 const matches = useMediaQuery("(min-width: 991px)");
  return (
    <section className="header-section">
    <div className="container justify-content-between align-items-center">
      <div className="row pt-0 mt-100">
        {/* <div className="col-md-8"> */}
          <div className={matches ? "col-md-9" : "col-md-12"}>
          <Navbar
            expand="lg"
            expanded={expanded}
            className="w-100 d-flex justify-content-between me-0 me-lg-5"
          >
            <Navbar.Brand>
              <div className="logo" style={{ width: "140px" }}>
                <Link to="https://tecmch.co.uk/">
                  <img className="img-fluid" src={weblogo} alt="TecMCH logo featuring sleek lettering and a contemporary design that represents technology and innovation." />
                </Link>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={() => setExpanded(!expanded)}
            />
            <Navbar.Collapse id="basic-navbar-nav" style={{ paddingTop: "20px" }}>
              <Nav onClick={closeNavbar}>
                <NavLink className="nav-link" to="/">
                  Home
                </NavLink>
                <NavLink className="nav-link pointer" to={"/pricing-plan"}>
                  Pricing
                </NavLink>
                {/* <Link
              className="nav-link"
              to="https://form-tecmch.techvezoto.com/order-a-device/"
            >
              Order a Device
            </Link> */}
                <Link
                  className="nav-link"
                  to="/book-a-demo"
                >
                  Book a Demo
                </Link>
                {/* Removed Get a Free Quote per request */}
                <NavLink className="nav-link" to="/about-us">
                  About Us
                </NavLink>
                <NavLink className="nav-link" to="/contact-us">
                  Contact Us
                </NavLink>
                <NavLink className="nav-link" to="/apk-download">
                Download APK 
                </NavLink>
                {/* <NavLink className="nav-link" to="/blog">
              Blog
            </NavLink> */}

                {/* Show Community link inside navbar only on mobile */}
                <NavLink
                  className="nav-link d-lg-none"
                  to="https://social.techgv.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Community
                </NavLink>
                <NavLink
                  className="nav-link d-lg-none"
                  to="https://tecmch.online/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Login
                </NavLink>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
        <div className="col-md-1 justify-content-between" style={{ marginTop: "3.39em", display: matches ? "" : "none" }}>
          <p
            className="fade-right d-none d-lg-block"
            style={{ textAlign: "center" }}
          >
            <Link
              to="https://social.techgv.co.uk/"
              className="btn btn-outline-white btn-No-Login"
              target="_blank"
              rel="noopener noreferrer"
            >
              Community
            </Link>
          </p>
        </div>
        <div className="col-md-2 justify-content-between" style={{ marginTop: "3.39em", display: matches ? "" : "none" }}>
          <p
            className="fade-right d-none d-lg-block justify-content-between"
            style={{ textAlign: "center" }}
          >
            <Link
              to="https://tecmch.online/"
              className="btn btn-outline-white btn-No-Login2 ms-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Login
            </Link>
          </p>
        </div>

        {/* Show Community button only on desktop */}
      </div>
    </div>
    </section>
  );
}
